import { Promise } from 'es6-promise';
import { action, observable } from "mobx";
import { Strings } from "./StringsStore";

export enum DialogResult {
	Yes,
	No,
	Cancel
}

export enum DialogType {
	Feedback,
	DeepLink,
	DeleteConfirmation,
	Default,
	None
}

class DialogStoreImpl {
	@observable open: boolean;
	@observable title: string;
	@observable text: any;
	@observable subject: string;
	@observable message: string;
	dialogType: DialogType;
	resolve: (result: DialogResult) => void;

	onSubjectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.subject = event.target.value;
	}

	onMessageChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		this.message = event.target.value;
	}

	@action show(title: string, text: string): Promise<DialogResult> {
		this.dialogType = DialogType.Default;
		return this.showDialog(title, text);
	}

	@action showError(title: string, text: string) {
		this.dialogType = DialogType.None;
		return this.showDialog(title, text);
	}

	@action showDeleteConfirmation(title: string, text: string): Promise<DialogResult> {
		this.dialogType = DialogType.DeleteConfirmation;
		return this.showDialog(title, text);
	}

	@action showContent(title: string, content: JSX.Element) {
		this.dialogType = DialogType.None;
		this.showDialog(title, content);
	}

	@action showDeepLink(link: string) {
		this.dialogType = DialogType.DeepLink;
		this.showDialog(Strings.reader.createDeepLinkTitle, link);
	}

	@action showFeedback(fileName: string): Promise<DialogResult> {
		this.dialogType = DialogType.Feedback;
		this.subject = fileName;
		this.message = "";
		return this.showDialog(Strings.reader.sendFeedbackTitle, fileName);
	}

	private showDialog(title: string, text: any): Promise<DialogResult> {
		this.title = title;
		this.text = text;
		this.open = true;
		return new Promise<DialogResult>((resolve: (result: DialogResult) => void, reject: (error: string) => void) => {
			this.resolve = resolve;
		});
	}
}

export var DialogStore: DialogStoreImpl = new DialogStoreImpl();

